module.exports = __webpack_public_path__ + "static/img/coupon.5cf201c7.png";